import { Container, Card, CardMedia, CardContent, Typography, Grid2 } from '@mui/material';
import './Meet.css';
import React from "react";
import WilliamWillson from "../../Assets/WilliamWillson.jpg";
import KyleSouthall from "../../Assets/KyleSouthall.jpg";

function Meet() {
  return (
    <Container
      sx={{
        marginTop: "20px",
        marginBottom: "20px",
      }}
    >
      <Grid2
        container
        spacing={3}
        direction="row"
        sx={{
          justifyContent: "center",
          alignItems: "flex-start",
        }}
      >
        <Card sx={{ maxWidth: 500 }}>
          <CardContent>
            <Typography gutterBottom variant="h5" component="div">
              William Wilson
            </Typography>
            <Typography gutterBottom variant="body2" sx={{ color: 'text.secondary' }}>
              Anyone who knows me knows that for the past three years, bagels have been my favourite (and only) topic of conversation - so it was only a matter of time before I made them my life. Moving down south for university and spending time in London opened my eyes to a whole new food scene. After learning how to put holes in buns (in more ways than one), I knew I had to bring proper, filled bagels back up to the north, and bring them up right. 
            </Typography>
            <Typography gutterBottom variant="body2" sx={{ color: 'text.secondary' }}>
              My love for food started with my first job in a Michelin Bib Gourmand restaurant, where I was supposed to be waiting tables but kept getting distracted watching the chefs work. Their skill and dedication to precision had me hooked, and now I want to put that same passion into every bagel we make.
            </Typography>
          </CardContent>
          <CardMedia
            component="img"
            alt="William Willson"
            image={WilliamWillson}
          />
          <CardContent>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Above: A photo of me in London pretending to be nonchalant.
            </Typography>
          </CardContent>
        </Card>
        <Card sx={{ maxWidth: 500 }}>
          <CardContent>
            <Typography gutterBottom variant="h5" component="div">
              Kyle Southall
            </Typography>
            <Typography gutterBottom variant="body2" sx={{ color: 'text.secondary' }}>
              Since finishing college, I've spent my time primarily in kitchens, picking up everything I could about food, operations, and the madness that is the hospitality industry. And boy is it wild! Along the way, I've been searching for a way to push my skills, get creative, and figure out where my real passion lies. Turns out, it's easier to stick 'things' in bagel holes rather than punching holes through a sandwich.  
            </Typography>
            <Typography gutterBottom variant="body2" sx={{ color: 'text.secondary' }}>
              Eventually, Will's endless talk about bagels got to me, and now I share the same enthusiasm as him. Perfecting everything, from the crust, to the flavours of the fillings, is my passion. Let's be honest, getting to eat bagels everyday as a job isn't a bad deal now is it?
            </Typography>
          </CardContent>
          <CardMedia
            component="img"
            alt="Kyle Southall"
            image={KyleSouthall}
          />
          <CardContent>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Above: A <s>Viking</s> Bagel warrior
            </Typography>
          </CardContent>
        </Card>
      </Grid2>
    </Container>
  );
}

export default Meet;
